/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

import { isTokenValid } from "services/auth";

class AdminNavbar extends React.Component {

  state = {
    isTokenValid : false
  }

  componentDidMount(){

    isTokenValid().then( result => {
      if ( !result ){
        this.setState( { isTokenValid: false } );
      } else {
        this.setState( { isTokenValid: true } )
      }
    } )

  }

  render() {
    return (
      <>
        <Navbar
          className="navbar-horizontal navbar-main navbar-dark bg-danger"
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <NavbarBrand to="/" tag={Link}>
              <img
                alt="..."
                src={require("assets/img/brand/smartflow-white.png")}
              />
            </NavbarBrand>
            <button
              aria-controls="navbar-collapse"
              aria-expanded={false}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              data-target="#navbar-collapse"
              data-toggle="collapse"
              id="navbar-collapse"
              type="button"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <UncontrolledCollapse
              className="navbar-custom-collapse"
              navbar
              toggler="#navbar-collapse"
            >
              <div className="navbar-collapse-header">
                <Row>
                  <Col className="collapse-brand" xs="6">
                    <Link to="/admin/dashboard">
                      <img
                        alt="..."
                        src={require("assets/img/brand/smartflow-white.png")}
                      />
                    </Link>
                  </Col>
                  <Col className="collapse-close" xs="6">
                    <button
                      aria-controls="navbar-collapse"
                      aria-expanded={false}
                      aria-label="Toggle navigation"
                      className="navbar-toggler"
                      data-target="#navbar-collapse"
                      data-toggle="collapse"
                      id="navbar-collapse"
                      type="button"
                    >
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>
              </div>
              <Nav className="mr-auto" navbar>
                {!this.state.isTokenValid ? (
                  <NavItem>
                    <NavLink to="/auth/login" tag={Link}>
                      <span className="nav-link-inner--text">Login</span>
                    </NavLink>
                  </NavItem>
                ):(
                  <NavItem>
                    <NavLink to="/admin/feed" tag={Link}>
                      <span className="nav-link-inner--text">Acessar o SmartFlow</span>
                    </NavLink>
                  </NavItem>
                )}
                {/* {!this.state.isTokenValid ? (
                  <NavItem>
                    <NavLink to="/auth/register" tag={Link}>
                      <span className="nav-link-inner--text">Solicitar Acesso</span>
                    </NavLink>
                  </NavItem>
                ):(null)} */}
              </Nav>
              <hr className="d-lg-none" />
              <Nav className="align-items-lg-center ml-lg-auto" navbar>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.youtube.com/channel/UCjiPY3BAIGP5stY2IAVkvNg"
                    id="tooltip601201423"
                    target="_blank"
                  >
                    <i className="fab fa-youtube" />
                    <span className="nav-link-inner--text d-lg-none">
                      YouTube
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip601201423">
                    Acompanhe-nos no YouTube
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://api.whatsapp.com/send?phone=5541987232486&text=Quero%20conhecer%20as%20solu%c3%a7%c3%b5es%20Golive!"
                    id="tooltip871243015"
                    target="_blank"
                  >
                    <i className="fab fa-whatsapp" />
                    <span className="nav-link-inner--text d-lg-none">
                      WhatsApp
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip871243015">
                    Compartilhe no WhatsApp
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.facebook.com/GoLiveconsultoria/"
                    id="tooltip366258619"
                    target="_blank"
                  >
                    <i className="fab fa-facebook-square" />
                    <span className="nav-link-inner--text d-lg-none">
                      Facebook
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip366258619">
                    Curta Golive Consultoria no Facebook
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.instagram.com/goliveconsultoria/"
                    id="tooltip931502898"
                    target="_blank"
                  >
                    <i className="fab fa-instagram" />
                    <span className="nav-link-inner--text d-lg-none">
                      Instagram
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip931502898">
                    Siga-nos no Instagram
                  </UncontrolledTooltip>
                </NavItem>
              </Nav>
            </UncontrolledCollapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
